import icon1 from "../img/icon.png"
import icon2 from "../img/icon2.png"
import icon3 from "../img/icon3.png"
import { useSpring, animated } from 'react-spring'

export const BannerDown = () =>{

    const styles = useSpring({
        from: { opacity: "0" },
        to: [
          { opacity: "1" },
          { opacity: "1"},
        ],
        config: { duration: "3500" },
        loop:false
    })
    return(
        <section className="banner-down flex container">
            <div className="flex" >
                <img src={icon1} style={styles} />
                <div className="banner-down-text">
                    <animated.h2 style={styles}>90+</animated.h2>
                    <animated.h3 style={styles}>Users</animated.h3>
                </div>
            </div>

            <div className="flex" >
                <img src={icon2} />
                <div className="banner-down-text">
                    <animated.h2 style={styles}>30+</animated.h2>
                    <animated.h3 style={styles}>Locations</animated.h3>
                </div>
            </div>

            <div className="flex" >
                <img src={icon3} />
                <div className="banner-down-text">
                    <animated.h2 style={styles}>50+</animated.h2>
                    <animated.h3 style={styles}>Servers</animated.h3>
                </div>
            </div>
            
           
        </section>
    )
}